import { List } from 'antd';
import CustomListItem from 'app/components/CustomListItem/CustomListItem';
import { selectSelectedEnvId } from 'app/containers/HiikoEnv/slice/selectors';
import { useTaskSlice } from 'app/containers/Task/slice';
import { RouteConstants } from 'app/routes';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { generatePath, useHistory } from 'react-router-dom';
import { selectResourceAllocationTaskCategories } from '../../slice/selectors';

import * as S from './TaskCategories.styles';

interface IProps {}

const TaskCategoriesCard = (props: IProps) => {
  const { t } = useTranslation();

  const { actions: taskActions } = useTaskSlice();

  const dispatch = useDispatch();

  const history = useHistory();

  const envId = useSelector(selectSelectedEnvId);

  const { categoriesArr, loading } = useSelector(
    selectResourceAllocationTaskCategories,
  );

  useEffect(() => {
    if (envId) {
      dispatch(taskActions.getTaskCategories(envId));
    }
  }, [envId, taskActions, dispatch]);

  const onListItemClick = (taskCategoryId: number) => () => {
    if (envId) {
      history.push(
        generatePath(RouteConstants.resource.resourceAllocationTaskCategory, {
          envId,
          taskCategoryId,
        }),
      );
    }
  };

  return (
    <S.ListCard
      bordered={false}
      title={t('Resource.TaskCategoriesCard.Title', 'Task groups')}
    >
      <List
        loading={loading}
        itemLayout="horizontal"
        dataSource={categoriesArr}
        renderItem={({ id, name, isSelected }) => {
          return (
            <CustomListItem
              key={id}
              isActive={isSelected}
              onClick={onListItemClick(id)}
            >
              <List.Item.Meta title={name} />
            </CustomListItem>
          );
        }}
      />
    </S.ListCard>
  );
};

export default TaskCategoriesCard;
